import { useDispatch } from 'react-redux';
import { setSnackbar } from 'redux/reducers';
import { MenuItem } from '@mui/material';
import { TextFieldRow } from 'components';
import { makeStyles } from '@mui/styles';

export const RoleSelector = ({
	role,
	onChange,
	disableMessage,
	originalRole,
}) => {
	const useStyles = makeStyles(() => ({
		roleSelectorTextField: {
			margin: '16px 0',
		},
	}));

	const classes = useStyles();
	const dispatch = useDispatch();
	const roleList = [
		{
			value: 'social-worker',
			label: 'Social Worker',
			disabled: originalRole === 'social-worker' ? true : false,
		},
		{
			value: 'manager',
			label: 'Manager',
			disabled: originalRole === 'manager' ? true : false,
		},
		{
			value: 'admin',
			label: 'Admin',
			disabled: originalRole === 'admin' ? true : false,
		},
	];

	const roleListMap = roleList.map((val) => {
		return val ? (
			<MenuItem key={val.value} value={val.value} disabled={val.disabled}>
				{val.label}
			</MenuItem>
		) : null;
	});

	const handleRoleChange = (e) => {
		const { value } = e?.target || {};
		onChange(value);
	};

	const handleClick = () => {
		!!disableMessage &&
			dispatch(
				setSnackbar({
					variant: 'error',
					message: disableMessage,
				})
			);
	};

	return (
		<TextFieldRow
			select
			className={classes.roleSelectorTextField}
			label='Role'
			value={role}
			disabled={!!disableMessage}
			onChange={handleRoleChange}
			onClick={handleClick}>
			{roleListMap}
		</TextFieldRow>
	);
};

export default RoleSelector;
